import { Box, CssBaseline, Toolbar, CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import { MainListItems } from '../../components/Navbar/listItems';
import NewNavbar from '../../components/Navbar/New/Navbar';
import Sidebar from '../../components/Navbar/Sidebar';
import theme from '../../mui-theme';
import FloatingButton from '../../components/elements/Floating-Button';
import { useAccess } from '../../hooks/useAccess';

const DashboardLayout = ({ children }) => {
  const { isReady } = useAccess();
  const isSmallScreen = window.innerWidth < 1025;

  const [open, setOpen] = useState(!isSmallScreen);
  const drawerWidth = isSmallScreen ? 180 : 240;

  const toggleDrawer = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
      <Box display="flex">
        <CssBaseline />
        <NewNavbar />
        <Sidebar
          theme={theme}
          MainListItems={MainListItems}
          open={open}
          toggleDrawer={toggleDrawer}
          type="dashboard"
          isSmallScreen={isSmallScreen}
          drawerWidth={drawerWidth}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
            padding: '16px',
            ml: open ? `${drawerWidth}px` : 7,
          }}>
          <Toolbar />
          <Box sx={{ flexGrow: 1, padding: '16px' }}>
            {!isReady ? (
              <Box 
                display="flex" 
                justifyContent="center" 
                alignItems="center" 
                minHeight="50vh"
              >
                <CircularProgress />
              </Box>
            ) : (
              children
            )}
          </Box>
          <FloatingButton />
        </Box>
      </Box>
  );
};

export default DashboardLayout;
